module.exports = "/_next/static/images/CompanyServices-37956d36dd0bbfa95996cf40518251fb.jpg.webp";